<template>
	<Row class="flex-align-center combo-item-container width-100">
		<ComboboxEmailItem v-if="isUserMatchingItem" v-bind="itemProps" />
		<ComboboxUserItem v-else-if="item.user_id" v-bind="itemProps" />
		<ComboboxGroupItem v-else-if="item.isGroup" v-bind="itemProps" />
	</Row>
</template>
<script>
import { USER_MATCHING_ITEM_PREFIX } from '@/components/dialogs/ShareModuleDialog/share-module-dialog.const.js';
import ComboboxUserItem from '@/components/dialogs/ShareModuleDialog/UserSelectComboboxItem/ComboboxUserItem.vue';
import ComboboxGroupItem from '@/components/dialogs/ShareModuleDialog/UserSelectComboboxItem/ComboboxGroupItem.vue';
import ComboboxEmailItem from '@/components/dialogs/ShareModuleDialog/UserSelectComboboxItem/ComboboxEmailItem.vue';
export default {
	name: 'UserSelectComboboxItem',
	components: { ComboboxUserItem, ComboboxGroupItem, ComboboxEmailItem },
	props: { item: { type: Object }, size: { type: Number, default: 35 } },
	computed: {
		isUserMatchingItem() {
			return this.item.itemId?.includes(USER_MATCHING_ITEM_PREFIX);
		},
		itemProps() {
			return { item: this.item, size: this.size };
		},
	},
};
</script>
<style scoped lang="scss">
.combo-item-container {
	min-height: 60px;
}
</style>
